<template>
    <div>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar producto</h6>
                <div class="form-group">
                    <label>Animales o productos almacenados *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="animales o productos almacenados"
                                placeholder="animales o productos almacenados"
                                autocomplete="off"
                                v-validate="modelValidations.productName"
                                :error="getError('animales o productos almacenados')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Venta proyectada</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="venta proyectada"
                                placeholder="venta proyectada"
                                autocomplete="off"
                                v-validate="modelValidations.productSale"
                                :error="getError('venta proyectada')"
                                v-model="productSale">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de venta</label>
                    <vue-numeric  :max=999999999 tabindex="8" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.productSaleValue" :error="getError('precio de venta')" separator="." class="form-control" v-model="productSaleValue"></vue-numeric>
                    <span v-show="errors.has('precio de venta')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('precio de venta') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Ingreso total</label>
                    <vue-numeric  disabled :max=99999999999999 tabindex="8" currency="$" autocomplete="off" name="ingreso total" v-validate="modelValidations.productSaleTotal" :error="getError('ingreso total')" separator="." class="form-control" v-model="productSaleTotalComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Fecha proyectada</label>
                    <el-date-picker
                        v-model="productDate"
                        type="month"
                        placeholder="Seleccione fecha proyectada">
                    </el-date-picker>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar producto</h6>
            <div class="form-group">
                    <label>Animales o productos almacenados *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="animales o productos almacenados"
                                placeholder="animales o productos almacenados"
                                autocomplete="off"
                                v-validate="modelValidations.productName"
                                :error="getError('animales o productos almacenados')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Venta proyectada</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="venta proyectada"
                                placeholder="venta proyectada"
                                autocomplete="off"
                                v-validate="modelValidations.productSale"
                                :error="getError('venta proyectada')"
                                v-model="productSale">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de venta</label>
                    <vue-numeric  :max=999999999 tabindex="8" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.productSaleValue" :error="getError('precio de venta')" separator="." class="form-control" v-model="productSaleValue"></vue-numeric>
                    <span v-show="errors.has('precio de venta')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('precio de venta') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Ingreso total</label>
                    <vue-numeric  disabled :max=999999999 tabindex="8" currency="$" autocomplete="off" name="ingreso total" v-validate="modelValidations.productSaleTotal" :error="getError('ingreso total')" separator="." class="form-control" v-model="productSaleTotalComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Fecha proyectada</label>
                    <el-date-picker
                        v-model="productDate"
                        type="month"
                        placeholder="Seleccione fecha proyectada">
                    </el-date-picker>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Inventory -->
        <card  class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Ingresos por ventas de productos almacenados</h6>
                <h5 class="card-subtitle" style="color: #b0b0b0; font-size: 0.9rem;">(Agrícolas / Pecuarios / Animales durante ciclo a financiar)</h5>
            </div>
            <div class="card-body">
                <el-table v-if="products.length" :data="products"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Producto:{{ props.row.productName }}</p>
                            <p>Venta proyectada: {{ props.row.productSale }}</p>
                            <p>Precio de venta: {{ setFormat(props.row.productSaleValue) }}</p>
                            <p>Ingreso total: {{ setFormat(props.row.productSaleTotal) }}</p>
                            <p>Fecha proyectada: {{ formatDate(props.row.productDate) }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Producto" property="productName"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.productSaleTotal )}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Fecha proyectada">
                        <template slot-scope="scope">
                            <span >{{ formatDate(scope.row.productDate) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div>
                    <p-button 
                        v-if="products.length < 8"
                        @click="addProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar producto
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar producto
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar producto
                    </p-button>
                </div>
            </div>
            <div class="card-footer">
                
            </div>
        </card>
        <div class="text-right">
            <p-button @click="saveData()" type="warning">Siguiente</p-button>
            <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn, DatePicker} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    import { Validator } from "vee-validate";
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Table)
    Vue.use(TableColumn)
    Validator.extend('no_leading_zeros', {
        validate: (value) => {
            value = String(value).trim();

            // Permitir exactamente "0"
            if (value === '0') return true;

            // No permitir ceros a la izquierda (excepto "0" como único valor)
            if (/^0\d+/.test(value)) return false;

            // Rechazar números que son exactamente 0.0000 (o equivalentes)
            if (parseFloat(value) === 0) return false;

            // Debe ser un número válido (enteros o decimales positivos)
            return /^\d+(\.\d+)?$/.test(value);
        },
        getMessage: field => `${field} no debe tener ceros a la izquierda.`
    });
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            [DatePicker.name]: DatePicker,
        },
        data() {
        return {
            cashFlowData: null,
            form: {
                average_selection: '',
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
            },
            microcredit: false,
            consumer: false,
            pyme: false,
            expenses : [],
            actualExpenses: [],
            currentRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            productName: '',
            productSale: '',
            productSaleValue: '',
            productSaleTotal: '',
            productDate: '',
            referenceDescription: '',
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                productName: {
                    required: true,
                    max: 50,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                productSale: {
                    required: false,
                    max: 5,
                    no_leading_zeros: true
                },
                productSaleValue: {
                    required: false
                },
                productSaleTotal: {
                    required: false
                },
                productDate: {
                    required: false
                }
            },
        }
        },
        watch: {
           
        },
        computed: {


            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productSaleTotalComputed () {
                if(this.productSale != '' && this.productSaleValue != '') {
                    this.productSaleTotal = parseFloat(this.productSale) * parseFloat(this.productSaleValue);
                    return this.productSaleTotal;
                }
                else {
                    this.productSaleTotal = 0;
                    return 0
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allExpensesMonthlyCostComputed != 0 && this.totalInventory != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allExpensesMonthlyCostComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalInventory ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productSaleUnity;
                this.productCostTotal = total;
                return total;
            },
            
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    sum = sum + (this.actualExpenses[i].value);
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed
            }
        },
        methods: {
            // calculateMonthlyTotalsForProducts() {
            //     const productTotalsByMonth = {};
            //     let totalProducts = 0; // Inicializamos la variable totalProducts

            //     // Agrupar las proyecciones de productos por mes
            //     this.products.forEach((product) => {
            //         const productDate = new Date(product.productDate);
            //         const month = productDate.getMonth() + 1;
            //         const year = productDate.getFullYear();
            //         const key = `${month}-${year}`;

            //         if (!productTotalsByMonth[key]) {
            //         productTotalsByMonth[key] = 0;
            //         }

            //         productTotalsByMonth[key] += product.productSaleTotal;
            //         // Acumulamos el total de todos los productos
            //         totalProducts += product.productSaleTotal;
            //     });

            //     // Añadir los totales al cashFlowData
            //     this.cashFlowData.months.forEach((cashFlowMonth) => {
            //         const key = `${cashFlowMonth.month}-${cashFlowMonth.year}`;
            //         if (!cashFlowMonth.products) {
            //         cashFlowMonth.products = 0;
            //         }
            //         cashFlowMonth.products = productTotalsByMonth[key] || 0;
            //     });
            //     // Guardamos el total de productos en totalProducts
            //     this.$set(this.cashFlowData, "totalProducts", totalProducts);
            // },
            calculateMonthlyTotalsForProducts() {
                const productTotalsByMonth = {};
                let totalProducts = 0; // Inicializamos la variable totalProducts

                // 🔹 Crear un conjunto con los meses válidos en cashFlowData.months
                const validMonths = new Set(this.cashFlowData.months.map(m => `${m.month}-${m.year}`));

                // 🔹 Agrupar las proyecciones de productos por mes
                this.products.forEach((product) => {
                    const productDate = new Date(product.productDate);
                    const month = productDate.getMonth() + 1;
                    const year = productDate.getFullYear();
                    const key = `${month}-${year}`;

                    // 🛑 Solo procesamos el producto si el mes está en los meses válidos
                    if (!validMonths.has(key)) return; 

                    if (!productTotalsByMonth[key]) {
                        productTotalsByMonth[key] = 0;
                    }

                    productTotalsByMonth[key] += product.productSaleTotal;
                    // Acumulamos el total de todos los productos (pero solo los válidos)
                    totalProducts += product.productSaleTotal;
                });

                // 🔹 Añadir los totales al cashFlowData.months
                this.cashFlowData.months.forEach((cashFlowMonth) => {
                    const key = `${cashFlowMonth.month}-${cashFlowMonth.year}`;
                    if (!cashFlowMonth.products) {
                        cashFlowMonth.products = 0;
                    }
                    cashFlowMonth.products = productTotalsByMonth[key] || 0;
                });

                // 🔹 Guardamos el total de productos en totalProducts
                this.$set(this.cashFlowData, "totalProducts", totalProducts);
            },

            toMenu () {
                this.$router.push('/asessments/menu');
            },
            formatDate(date) {
                if (!date) return '';
                const formattedDate = new Date(date).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit'
                });
                return formattedDate;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (this.$store.state.isCustomer) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    
                }
                else if(this.$store.state.isSpouse) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    
                }
                if (this.$store.state.isGuarantor) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var index = this.actualExpenses.indexOf(this.currentRow);
                    this.actualExpenses[index].name = this.expenseName;
                    this.actualExpenses[index].value = this.expenseValue;
                    this.resetExpense();
                    this.currentRow = null;
                    this.$refs.expensesTable.setCurrentRow();
                    this.editExpense = false;
                    this.showNotificationSuccess('Gasto editado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        this.products.push({
                            productName: this.productName,
                            productSale: parseFloat(this.productSale) || 0,
                            productSaleValue: parseFloat(this.productSaleValue) || 0,
                            productSaleTotal: parseFloat(this.productSaleTotal) || 0,
                            productDate: this.productDate
                        })
                        this.resetProduct();
                        this.addProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Producto agregado correctamente');
                        }
                        else {
                            console.error('Error: Campos no diligenciados correctamente');
                            console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                            this.errors.items.forEach(error => {
                                console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                            });
                            this.showNotificationError('Campos no diligenciados correctamente');
                        }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.productName = '';
                this.productSale = '';
                this.productSaleValue = '';
                this.productSaleTotal = '';
                this.productDate = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.productName =  this.currentRow.productName;
                this.productSale =  this.currentRow.productSale;
                this.productSaleValue =  this.currentRow.productSaleValue;
                this.productSaleTotal =  this.currentRow.productSaleTotal;
                this.productDate =  this.currentRow.productDate;
                this.editProduct = true;  
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].productName = this.productName;
                            this.products[index].productSale = parseFloat(this.productSale) || 0;
                            this.products[index].productSaleValue = parseFloat(this.productSaleValue) || 0;
                            this.products[index].productSaleTotal = parseFloat(this.productSaleTotal) || 0;
                            this.products[index].productDate = this.productDate;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.errors.clear();
                            this.showNotificationSuccess('Producto editado correctamente');
                        }
                })
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (row) {
                this.addProductIndex = row;
                this.errors.clear();
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productSaleUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
                this.productSaleValue = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var id = this.actualExpenses.length + 1;
                    this.actualExpenses.push({
                        id: id,
                        name: this.expenseName,
                        value: this.expenseValue,
                        locked: false
                    })
                    this.resetExpense();
                    this.addExpense = false;
                    this.showNotificationSuccess('Gasto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveData () {
                if (this.products.length != 0) {
                    this.calculateMonthlyTotalsForProducts();
                    this.$store.dispatch('setAgroProduct', { form: this.products, cashFlowData: this.cashFlowData }).then(()=>{
                        var vm = this;
                        const routes = [
                            {
                                title: '¿Deseas agregar Ingresos por ventas estacionales?',
                                text: 'Si aceptas, podrás agregar o editar la información de Ingresos por ventas estacionales',
                                route: '/asessments/new_asessment/customer/agro/seasonal_sales'
                            },
                            {
                                title: '¿Deseas agregar Ingresos por jornales o salarios a la actividad agropecuaria?',
                                text: 'Si aceptas, podrás agregar o editar la información de Ingresos por jornales o salarios a la actividad agropecuaria',
                                route: '/asessments/new_asessment/customer/agro/salary'
                            }
                        ];
                        let currentIndex = 0;
                        function askRoute() {
                            if (currentIndex < routes.length) {
                                const current = routes[currentIndex];
                                swal({
                                    title: current.title,
                                    text: current.text,
                                    type: 'info',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, aceptar',
                                    cancelButtonText: 'No, continuar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.$router.push(current.route); // Redirige a la ruta correspondiente
                                }, (dismiss) => {
                                    if (dismiss === 'cancel') {
                                        currentIndex++; // Avanza al siguiente paso
                                        askRoute(); // Llama recursivamente para mostrar la siguiente pregunta
                                    } else {
                                        swal({
                                            title: 'Cancelado',
                                            text: 'El analista no ha continuado',
                                            type: 'error',
                                            confirmButtonClass: 'btn btn-info btn-fill',
                                            buttonsStyling: false
                                        });
                                    }
                                });
                            } else {
                                vm.$router.push('/asessments/new_asessment/customer/agro/expenses');
                            }
                        }
                        // Llama la función para iniciar el flujo
                        askRoute(); 
                    });
                }
                else {
                    this.showNotificationError('Debe ingresar datos de venta de productos almacenados');
                    // this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                }
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.product) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.product;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.product) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.product;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.product) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.product;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
